export default "__VITE_ASSET__AvYq1HVk__"